import React from 'react';
import { SideMenu } from './SideMenu';
import { SIDEMENU_NAVIGATION } from '@/shared/consts';

export const AdminSideMenu: React.FC = () => {
  return <SideMenu defaultPage={SIDEMENU_NAVIGATION.DOCS} />;
};
